const normalize = (value) => String(value ?? "").trim().toUpperCase();

const uniqueSorted = (values) =>
  [...new Set(values.map((value) => String(value ?? "").trim()).filter(Boolean))].sort();

export const mapBaseComuneRows = (comuneRows = [], standardRows = []) => {
  const groups = new Map();

  for (const row of comuneRows) {
    const key = `${normalize(row.Provincia)}\u0000${normalize(row.Nome)}`;
    const group = groups.get(key) ?? { rows: [] };
    group.rows.push(row);
    groups.set(key, group);
  }

  const mapped = [];

  for (const { rows } of groups.values()) {
    const codesInGroup = new Set(rows.map((row) => normalize(row.Codice)));
    let currentCodes = uniqueSorted(
      standardRows
        .filter((row) => codesInGroup.has(normalize(row.CodISTAT)))
        .map((row) => row.CodISTAT),
    );
    if (currentCodes.length === 0) {
      currentCodes = uniqueSorted(
        rows.filter((row) => !row.DataSoppressione).map((row) => row.Codice),
      );
    }
    if (currentCodes.length === 0) continue;

    const currentCodeSet = new Set(currentCodes.map(normalize));
    const historicalCodes = uniqueSorted(
      rows
        .filter((row) => !currentCodeSet.has(normalize(row.Codice)))
        .map((row) => row.Codice),
    );
    const currentRows = rows
      .filter((row) => currentCodeSet.has(normalize(row.Codice)))
      .sort((left, right) => Number(left.Id) - Number(right.Id));
    if (currentRows.length === 0) continue;

    const canonical = currentRows[0];
    const codiciBelfiore = uniqueSorted([
      ...rows.map((row) => row.CodBelfiore),
      ...standardRows
        .filter((row) => codesInGroup.has(normalize(row.CodISTAT)))
        .map((row) => row.CodiceBelfiore),
    ]);

    mapped.push({
      id: canonical.Id,
      nome: canonical.Nome,
      provincia: canonical.Provincia,
      codice: currentCodes[0],
      codiceIstatAttuale: currentCodes[0],
      codiciIstatAttuali: currentCodes,
      codiceIstatStorico: historicalCodes.length === 1 ? historicalCodes[0] : null,
      codiciIstatStorici: historicalCodes,
      codBelfiore: codiciBelfiore[0] ?? null,
      codiciBelfiore,
    });
  }

  return mapped.sort(
    (left, right) =>
      normalize(left.nome).localeCompare(normalize(right.nome)) ||
      normalize(left.provincia).localeCompare(normalize(right.provincia)),
  );
};